export const CREATE_SADDLE_FAVORITE = /* GraphQL */ `
  mutation createSaddleFavorite($input: SaddleFavoriteInput!) {
    createSaddleFavorite(input: $input) {
      createdAt
      horseId
      saddleId
      score
      updatedAt
      userId
      saddle {
        pk
        sk
        type
        brandName
        createdAt
        discipline
        manufacturerMeasurements {
          gulletWidth
          gulletHeight
          barAngle
        }
        measurements {
          gulletWidth
          gulletHeight
          barAngle
        }
        brandName
        newOrUsed
        price
        photo
        productTitle
        gallery
        quantity
        size
        status
        description
        score
        updatedAt
        variantId
        userId 
      }
    }
  }
`;


export const DELETE_SADDLE_FAVORITE = /* GraphQL */ `
  mutation deleteSaddleFavorite($saddleId: ID!) { 
    deleteSaddleFavorite(saddleId: $saddleId) {
      id
    }
  }
`;